import { render, staticRenderFns } from "./LectureSidebar.vue?vue&type=template&id=574337f5&"
import script from "./LectureSidebar.vue?vue&type=script&lang=js&"
export * from "./LectureSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LectureSidebar.vue?vue&type=style&index=0&id=574337f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports